import { attr, fk } from 'redux-orm'
import Base from './Base'

class BillingInvoice extends Base {
  static get fields () {
    return {
      id: attr(),
      identification: attr(),
      formattedIdentification: attr(),
      invoiceDate: attr(),
      dueDate: attr(),
      status: attr(),
      payedAt: attr(),
      paymentMethod: attr(),
      creditNoteReferenceInvoiceId: attr(),
      creditNoteReason: attr(),
      snapshot: attr(),
      priceTotal: attr(),
      vatTotal: attr(),
      peppyrusId: attr(),
      sendPeppolWarning: attr(),
      issuedAt: attr(),
      lastRemindedAt: attr(),
      pdfUrl: attr(),
      subscriptionId: fk('billingSubscription', 'invoices')
    }
  }
}

BillingInvoice.modelName = 'billingInvoice'

export default BillingInvoice
